import { render } from "./NimeePrivacyPolicy.vue?vue&type=template&id=f7486a40&scoped=true"
import script from "./NimeePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./NimeePrivacyPolicy.vue?vue&type=script&lang=js"

import "./NimeePrivacyPolicy.vue?vue&type=style&index=0&id=f7486a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7486a40"]])

export default __exports__